/**
 * Analytics + attribution tracking.
 * Safe no-op if gtag isn't loaded (dev/local).
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function trackEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
}

export function trackPageView(path, title) {
  trackEvent("page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
  });
}

export function trackConversion(name, params = {}) {
  trackEvent(name, params);
}

/** Fire-and-forget attribution event to backend. */
export async function logAttribution(source, meta = {}) {
  try {
    await axios.post(`${API}/attribution`, {
      source,
      path: window.location.pathname,
      ...meta,
    });
  } catch {
    /* silent */
  }
  trackEvent("attribution_source", { source });
}
